import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CurrencyResponse} from '../models/CurrencyModel';
import {Observable} from 'rxjs/internal/Observable';


const CURRENCY_URL = '/api/currency';
@Injectable({
    providedIn: 'root'
})
export class CurrencyService {
    constructor(private http: HttpClient) {
    }


    getCurrency(currency: string): Observable<CurrencyResponse> {
        const params = {currency: currency}
        return this.http.get<CurrencyResponse>(`${CURRENCY_URL}`, {params, withCredentials: true});
    }
}
